export const primaryColor = "#3f51b5";
export const backgroundColor = "#eef6fbff";
export const pageBgColor = "#F2F2F2";
export const masterDetailsMinHeight = "calc(100vh - 64px)";
export const autocompleteOptionColor = "#f4978e4f";
